<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Marque</h2>
    </div>
  </div>
  <CriteresRechercheMarque @fermer="fermer" @addMarqueFromList="addMarqueFromList"/>
  <ResultatRechercheMarque :listeMarqueFiltrer="listeMarqueFiltrer"
                           :isRechercheDataLoading="isRechercheDataLoading"
                           @removeMarqueFromList="removeMarqueFromList"/>
</template>

<script>
import CriteresRechercheMarque from '../../../../components/pilotage/Fichiers/Vehicule/CriteresRechercheMarque.vue'
import ResultatRechercheMarque from '../../../../components/pilotage/Fichiers/Vehicule/ResultatRechercheMarque.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheMarque,
    ResultatRechercheMarque
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Marque");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch('pilotage/obtenirMarquesAction')
        .then((res) => {
          this.listeMarque = res.data;
          this.listeMarqueFiltrer = this.listeMarque;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      isRechercheDataLoading: false,
      listeMarque: [],
      listeMarqueFiltrer: [],
    }
  },
  methods: {
    removeMarqueFromList(cle) {
      this.listeMarque = this.listeMarque.filter(current => (current.cle != cle))
      this.listeMarqueFiltrer = this.listeMarqueFiltrer.filter(current => (current.cle != cle))
    },
    addMarqueFromList(newMarque) {
      this.listeMarque.push(newMarque);
      this.listeMarqueFiltrer = this.listeMarque;
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
